import { Component, Input, OnChanges, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { Modal } from '../modal.model';
import { ModalService } from '../modal-list.service';

@Component({
  selector: 'modal-unit',
  templateUrl: './modal-unit.component.html',
  styleUrl: './modal-unit.component.scss',
  standalone: false,
})
export class ModalUnitComponent implements OnChanges {
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true }) dynamicContainer!: ViewContainerRef;
  @Input() modal!: Modal;

  constructor(private modalService: ModalService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dynamicContainer) {
      this.dynamicContainer?.clear();

      try {
        const componentRef = this.dynamicContainer?.createComponent(changes['modal'].currentValue.component);
        const comp = componentRef.instance as any;
        comp.data = changes['modal'].currentValue.data;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {}
    }
  }

  close() {
    this.modalService.skip();
    // this.modal.onSkip && this.modal.onSkip();
  }
}
